var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfoYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9992 7.67501C11.4014 7.67501 7.67422 11.4022 7.67422 16C7.67422 20.5978 11.4014 24.325 15.9992 24.325C20.597 24.325 24.3242 20.5978 24.3242 16C24.3242 11.4022 20.597 7.67501 15.9992 7.67501ZM6.32422 16C6.32422 10.6567 10.6559 6.32501 15.9992 6.32501C21.3426 6.32501 25.6742 10.6567 25.6742 16C25.6742 21.3434 21.3426 25.675 15.9992 25.675C10.6559 25.675 6.32422 21.3434 6.32422 16Z",
    fill: "#FEDA00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5742 15.25C14.5742 14.8772 14.8764 14.575 15.2492 14.575H15.9992C16.372 14.575 16.6742 14.8772 16.6742 15.25V19.825H16.7492C17.122 19.825 17.4242 20.1272 17.4242 20.5C17.4242 20.8728 17.122 21.175 16.7492 21.175H15.9992C15.6264 21.175 15.3242 20.8728 15.3242 20.5V15.925H15.2492C14.8764 15.925 14.5742 15.6228 14.5742 15.25Z",
    fill: "#FEDA00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13C16.6213 13 17.125 12.4963 17.125 11.875C17.125 11.2537 16.6213 10.75 16 10.75C15.3787 10.75 14.875 11.2537 14.875 11.875C14.875 12.4963 15.3787 13 16 13Z",
    fill: "#FEDA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoYellow);
export default __webpack_public_path__ + "static/media/infoYellow.7759e31cfe8b83ca80d4413e4e376255.svg";
export { ForwardRef as ReactComponent };